import React from 'react';
import { useUser } from '@lore/auth';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import { Helmet } from 'react-helmet-async';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';
import useIntents from '../../../hooks/useIntents';

export default function Layout(props) {
  const { history } = useRouter();

  const user = useUser();

  const navigation = useSetupNavigation(Urls.SKILLS_INTRODUCTION);

  const { isEducator } = useIntents();

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Skills Introduction</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={() => isEducator ? history.push(Urls.PARTNER_VALUE) : history.push(Urls.ORGANIZATION)}
        onNext={() => history.push(Urls.SKILLS)}
        onSkip={() => history.push(Urls.SKILLS)}
      />
    </ParentLayout>
  );
};
